import './index.css';
import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App";

const rootElement = document.getElementById("root");

if (!rootElement) {
  const errorDiv = document.createElement("div");
  errorDiv.style.cssText =
    "padding: 40px; text-align: center; font-family: sans-serif;";
  errorDiv.innerHTML = `<h1 style="color: red;">Configuration Error</h1><p>The 'root' element was not found in index.html.</p>`;
  document.body.appendChild(errorDiv);
} else {
  const root = ReactDOM.createRoot(rootElement);

  try {
    root.render(
      <React.StrictMode>
        <App />
      </React.StrictMode>,
    );
  } catch (error: any) {
    console.error("CRITICAL: App failed to render:", error);
    root.render(
      <div className="min-h-screen flex items-center justify-center bg-slate-50 p-6">
        <div className="max-w-md w-full bg-white p-8 rounded-3xl shadow-xl border border-red-100">
          <h1 className="text-2xl font-black text-red-600 mb-4 uppercase italic">
            Application Crash
          </h1>
          <p className="text-slate-600 text-sm mb-6 leading-relaxed">
            ScoutLoop failed to start. This is usually due to a missing
            dependency or a syntax error in your local files.
          </p>
          <div className="bg-slate-900 p-4 rounded-xl mb-6">
            <code className="text-xs text-pink-400 font-mono break-all">
              {error?.message || "Unknown Error"}
            </code>
          </div>
          <button
            onClick={() => window.location.reload()}
            className="w-full bg-slate-900 text-white py-3 rounded-xl font-bold uppercase tracking-widest text-xs"
          >
            Retry Connection
          </button>
        </div>
      </div>,
    );
  }
}

// Global error catcher for unhandled promises/errors
window.addEventListener("unhandledrejection", (event) => {
  console.error("Unhandled Promise Rejection:", event.reason);
});
